import { render, staticRenderFns } from "./pagos.vue?vue&type=template&id=43ee5204&"
import script from "./pagos.vue?vue&type=script&lang=ts&"
export * from "./pagos.vue?vue&type=script&lang=ts&"
import style0 from "./pagos.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports